var map = {
	"./algae.png": "4202",
	"./animals.png": "6774",
	"./carbon_dioxide.png": "ac07",
	"./carnivores.png": "4541",
	"./dead_land.png": "b873",
	"./dead_ocean.png": "0def",
	"./decomposers_land.png": "812e",
	"./decomposers_ocean.png": "d70d",
	"./factory.png": "956c",
	"./fish.png": "e731",
	"./fossil_fuel.png": "5260",
	"./herbivores.png": "7b80",
	"./plants.png": "4da9",
	"./tile_land.png": "bba3",
	"./tile_ocean.png": "96da",
	"./tile_selected.png": "f959"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba9f";